import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { CalendarDays } from 'lucide-react';

export function EnrollmentMonthFilter({ value, onChange, className = '' }) {
  // Generate last 12 months
  const months = [];
  const now = new Date();
  for (let i = 0; i < 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const val = d.toISOString().slice(0, 7); // "2026-04"
    const label = d.toLocaleDateString('en-GB', { month: 'short', year: 'numeric' }); // "Apr 2026"
    months.push({ value: val, label });
  }

  return (
    <Select value={value || 'all'} onValueChange={onChange}>
      <SelectTrigger className={`h-8 text-xs w-[150px] ${className}`} data-testid="enrollment-month-filter">
        <CalendarDays className="h-3 w-3 mr-1 shrink-0" />
        <SelectValue placeholder="Enrollment Month" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Months</SelectItem>
        {months.map(m => (
          <SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
